import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {
    Box,
    Button,
    Dialog, DialogContent,
    IconButton,
    InputAdornment,
    TextField,
    Typography,
} from '@mui/material';
import { useState } from 'react';

const PasswordPrompt = ({ open, onSubmit, error }) => {
    const [value, setValue] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(value);
    };

    return (
        <Dialog
            open={open}
            disableEscapeKeyDown
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
        >
            <DialogContent>
                <Box display="flex" flexDirection="column" alignItems="center" textAlign="center" gap={1} py={2}>
                    <Box
                        sx={{
                            width: 56,
                            height: 56,
                            borderRadius: '50%',
                            bgcolor: 'primary.main',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mb: 1,
                        }}
                    >
                        <LockOutlinedIcon sx={{ color: '#fff', fontSize: 28 }} />
                    </Box>
                    <Typography variant="h6" fontWeight={600}>
                        Enlace protegido
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Ingresa el código para ver este enlace
                    </Typography>
                    <Box component="form" onSubmit={handleSubmit} width="100%" mt={1}>
                        <TextField
                            autoFocus
                            fullWidth
                            type={showPassword ? 'text' : 'password'}
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            error={!!error}
                            helperText={error || ' '}
                            placeholder="Código de acceso"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setShowPassword((s) => !s)} edge="end" size="small">
                                            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Button type="submit" fullWidth variant="contained" sx={{ mt: 2, borderRadius: 2, py: 1.2 }}>
                            Continuar
                        </Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default PasswordPrompt;